import {
  Accordion,
  AccordionDetails,
  AccordionProps,
  AccordionSummary,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { FiChevronDown } from "react-icons/fi";
import { COLORS } from "../../../assets/theme";

interface Props extends AccordionProps {
  id: string;
  headerText: string;
}

const useStyles = makeStyles((_) => ({
  text: {
    fontFamily: "'Raleway', sans-serif",
  },
  headerText: {
    fontWeight: "bold",
    color: COLORS.blue_1,
    fontSize: 12,
    textTransform: "uppercase",
  },
  detail: {
    paddingTop: 0,
    paddingLeft: 8,
    paddingRight: 8,
    paddingBottom: 0,
  },
}));

const CustomAccordionDetailVehicle = ({
  id,
  headerText,
  children,
  ...rest
}: Props) => {
  const classes = useStyles();
  return (
    <Accordion elevation={0} {...rest}>
      <AccordionSummary
        expandIcon={<FiChevronDown size={20} color={COLORS.gray_2} />}
        aria-controls={`${id}-content`}
        id={`${id}-header`}
      >
        <Typography className={[classes.text, classes.headerText].join(" ")}>
          {headerText}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.detail}>{children}</AccordionDetails>
    </Accordion>
  );
};

export default CustomAccordionDetailVehicle;
